var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotifyReaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1666 19.0834H7.83329C5.33329 19.0834 3.66663 17.8334 3.66663 14.9167V9.08341C3.66663 6.16675 5.33329 4.91675 7.83329 4.91675H16.1666C18.6666 4.91675 20.3333 6.16675 20.3333 9.08341V14.9167C20.3333 17.8334 18.6666 19.0834 16.1666 19.0834Z",
    stroke: "#A3A1AA",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 9.5L13.5584 11.5833C12.7 12.2667 11.2917 12.2667 10.4334 11.5833L7.83337 9.5",
    stroke: "#A3A1AA",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyReaded);
export default __webpack_public_path__ + "static/media/notifyReaded.94872252.svg";
export { ForwardRef as ReactComponent };